import React from 'react'
import '../Project.css';
import { Parallax } from 'react-parallax';
import Image1 from '../../Gemco-Website-Images/projects/Morocco_paviloin_Dubai_EXPO.webp';

const Project_thirteen = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Morocco Pavilion — Expo 2020 Dubai</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>The Kingdom of Morocco's national pavilion at Expo 2020 Dubai — celebrated for its traditional Moroccan architecture and
                craftsmanship. One of the most acclaimed pavilions at the global event, attracting significant international visitor footfall across
                the six-month exposition.</p>
              <p>MAIN CONTRACTOR : Al Shafar</p>
              <p>MEP CONTRACTOR : -</p>
              <p>GEMCO SCOPE OF WORKS : Electrical and CHW works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_thirteen